import { ActivityModel } from './activity.model';

export class ActivityResponse {
  hasMore: boolean;
  logEvents: ActivityModel[];
}
